// extracted by mini-css-extract-plugin
module.exports = {"main":"BienAVendreNonAutorise_main__1DKNN","textImgWrp":"BienAVendreNonAutorise_textImgWrp__3JjRy","btnWrp":"BienAVendreNonAutorise_btnWrp__3aoDP"};